module.exports = __webpack_public_path__ + "static/media/bg_c.ef3d37e7.png";